import React, {useEffect, useState} from 'react';

import { ClipboardCopyIcon, DocumentTextIcon, SaveIcon } from '@heroicons/react/outline'

const UserStats = ({allUserMsg, copiedMsg, likedMsg}) => {

    const [ allProjects, setAllProjects ] = useState()

    useEffect(() => {
        const countProjects = () => {
            var arr = [];
            allUserMsg?.map(projects =>{
                if(projects.ContentCreated){
                    projects.ContentCreated.map(project => {
                        return arr.push(project)
                    })
                    return projects
                }else { 
                    return null
                }
            })
            setAllProjects(arr)
        }

        countProjects()
    }, [allUserMsg])

    var all = allProjects ? allProjects?.length : 0;
    var copied = (allProjects && copiedMsg) ? ((copiedMsg?.length / allProjects?.length) * 100) : 0
    var liked = (allProjects && likedMsg) ? ((likedMsg?.length / allProjects?.length) * 100) : 0

    const stats = [
        { name: 'Total Messages Created', stat:  all, icon: DocumentTextIcon,},
        { name: 'Copied Messages', stat:  copied.toFixed(2) === 'NaN' ? (0 + ' %') : copied.toFixed(2) + ' %', icon: ClipboardCopyIcon,},
        { name: 'Saved Messages', stat: liked.toFixed(2) === 'NaN' ? (0 + ' %') : liked.toFixed(2) + ' %',  icon: SaveIcon,},
    ]

    return (
        <div>
            <h2 className="text-gray-500 text-xs font-medium uppercase tracking-wide mt-10" style={{marginBottom: '20px'}}>Total Usage</h2>
            <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {stats.map((item) => (
                <div
                key={item.name}
                className="relative bg-white pt-5 px-4 pb-4 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden"
                >
                <dt>
                    <div className="absolute bg-indigo-500 rounded-md p-3">
                    <item.icon className="h-6 w-6 text-white" aria-hidden="true" />
                    </div>
                    <p className="ml-16 text-sm font-medium text-gray-500 truncate">{item.name}</p>
                </dt>
                <dd className="ml-16 pb-6 flex items-baseline sm:pb-7">
                    <p className="text-2xl font-semibold text-gray-900">{item.stat}</p>
                </dd>
                </div>
            ))}
            </dl>
        </div>
    )
}

export default UserStats